module.exports = __webpack_public_path__ + "img/applyClic.26ba915a.jpg";